import { render, staticRenderFns } from "./ChangelogLegacy.vue?vue&type=template&id=64f5217f&scoped=true"
import script from "./ChangelogLegacy.vue?vue&type=script&lang=js"
export * from "./ChangelogLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5217f",
  null
  
)

export default component.exports